export const initialTableDataState = {
    data: [],
    page: 0,
    rowsPerPage: 5,
    count: 0,
    sorting: "createdOn,desc",
    loading: false
}

export const initialFilterState = {
    number: "",
    cType: "",
    dateOrderedGt: null,
    dateOrderedLt: null
}

export const initialDetailsState = {
    loading: true
}

export const initialOrdiniSuggestionState = {
    menuItems: [],
    loading: false
}
